module.exports = __webpack_public_path__ + "static/media/SC_map@2x.8d31666a.png";